'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'bullseye-arrow';
var width = 576;
var height = 512;
var aliases = [127919];
var unicode = 'f648';
var svgPathData = ['M32 256c0 141.4 114.6 256 256 256S544 397.4 544 256c0-23.3-3.1-45.8-8.9-67.2-1.4 1.4-8.9 8.9-22.6 22.6-17.8-3-30.9-5.2-39.4-6.6 4.5 16.3 6.9 33.4 6.9 51.2 0 106-86 192-192 192S96 362 96 256 182 64 288 64c17.7 0 34.9 2.4 51.2 6.9-1.4-8.4-3.6-21.6-6.6-39.4 13.7-13.7 21.2-21.2 22.6-22.6-21.4-5.8-43.9-8.9-67.2-8.9-141.4 0-256 114.6-256 256zm112 0c0 79.5 64.5 144 144 144s144-64.5 144-144c0-12.9-1.7-25.4-4.9-37.3l-63.5 63.5c-10.9 31.3-40.6 53.8-75.6 53.8-44.2 0-80-35.8-80-80 0-35 22.5-64.7 53.8-75.6l63.5-63.5c-11.9-3.2-24.4-4.9-37.3-4.9-79.5 0-144 64.5-144 144z', 'M395.2 114.9L384 48 464-32 496 48 576 80 496 160 429.1 148.8 297 281 263 247 395.2 114.9z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBullseyeArrow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;